// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\ndiv.v-expansion-panels[data-v-7ba40b62] div.v-expansion-panel-content__wrap {\n  padding: 0 0 0 0 !important;\n}\n", ""]);
// Exports
module.exports = exports;
